import logo from './logo.svg';
import './App.css';
import Leetcode from './Contests/Leetcode';
import Codechef from './Contests/Codechef'
import Codeforces from './Contests/Codeforces'
import Main from './Contests/main'
import Atcoder from './Contests/Atcoder'
import Hackerearth from './Contests/Hackerearth'
import { UseSelector, useSelector } from 'react-redux/es/hooks/useSelector';
import { Store } from './Store';
import { Provider } from 'react-redux';
import { PageType } from './Constants';
function Routes(){
         const page=useSelector(state=>state.Reducer.page);
         if(page==PageType.MAIN_PAGE)
         {
            return <Main/>
         }
         if(page==PageType.ATCODER_PAGE)
         {
            return <Atcoder/>
         }
         if(page==PageType.CODECHEF_PAGE)
         {
            return <Codechef/>
         }
         if(page==PageType.LEETCODE_PAGE)
         {
            return <Leetcode/>
         }
         if(page==PageType.CODEFORCES_PAGE)
         {
            return <Codeforces/>;
         }
         if(page==PageType.HACKEREARTH_PAGE)
         {
            return <Hackerearth/>;
         }
}   
function App(){    
  return (
  <Provider store={Store}>
    <div className="App">
         <Routes/>
    </div>
  </Provider>
  );
}

export default App;
